import React from 'react';
import styled from '@emotion/styled';
import { SmallText } from 'ds/components/typography';
import { Link } from 'components/link';
import { Route } from 'config/routes';

const Root = styled(Link)`
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.neutrals.grey9};
  color: ${({ theme }) => theme.colors.neutrals.grey1};
  padding: ${({ theme }) => theme.spacing(1, 3)};
  border-radius: 100px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutrals.grey8};
  }
`;

interface TagProps {
  children: React.ReactNode;
  id: string;
  onClick?: () => void;
}

export const Tag: React.FC<TagProps> = ({ children, id, onClick }) => {
  return (
    <Root routeName={Route.MadadCity} routeParams={{ id }} onClick={onClick}>
      <SmallText>{children}</SmallText>
    </Root>
  );
};
